// @ts-nocheck
import { IconPresentationProps } from "@insite/mobius/Icon";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { linkActionStyles, linkIconStyles } from "@store/Themes/common/mixins/link";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

/* Store Custom Code - Start */
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
/* Store Custom Code - End */

export const linkGetIconProps = (
    src: IconPresentationProps["src"],
    position: "right" | "left" = "left",
    size?: IconPresentationProps["size"] | string,
): LinkPresentationProps["icon"] => ({
    position,
    iconProps: {
        src,
        color: "primary" /* Store Custom Code */,
        css: linkIconStyles(typeof size === "number" ? pxToRem(size) : size),
    },
});

export const linkGetActionLinkProps = (
    src?: IconPresentationProps["src"],
    position: "right" | "left" = "left",
    size?: IconPresentationProps["size"] | string,
): LinkPresentationProps => ({
    icon: linkGetIconProps(src, position, size),
    css: css`
        ${linkActionStyles()}
        align-items: flex-start;
    `,
});

/* Store Custom Code - Start */
/* Copied from starter/Themes/common/props/productLine.ts */
export const getLinkProps = (src?: IconPresentationProps["src"]) => {
    const spacing = pxToRem(6);

    return mergeProps<LinkPresentationProps>(linkGetActionLinkProps(src), {
        css: css`
            ${spacingStyles(spacing, spacing)}
            display: flex;
        `,
    });
};
/* Store Custom Code - End */
